import { createAsyncThunk } from '@reduxjs/toolkit'
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getUserData } from '../../utils/tools';
import { getAuthHeader,getAuthHeaderforimage } from '../../utils/tools';
import axios from 'axios';
import { updateMnCategories } from '../reducers/shopReducer';
import JSONBigInt from 'json-bigint';


axios.defaults.headers.post['Content-Type'] = 'application/json';
const BASE_URL="https://backend.nativehelper.com/news/"

//const BASE_URL="http://localhost:8080/"
//const BASE_URL="http://192.168.1.5:8080/"


//ADDING NEW SHOP 
export const addShop = createAsyncThunk(
    'shopReducer/addShop',
    async(shop,{ dispatch })=>{

        const shopData = {
           shopName:shop.shopName,
             shopTitle:shop.shopTitle,
             languageType:shop.languageType,
             userId:getUserData().userId,
             mcatId:shop.mcatId,
             subcatId:shop.subcatId,
              phNo:shop.phNo,
             districtID:shop.districtID,
             talukID:shop.talukID,
             region:1,
             priority:1,
             identity:shop.identity,
             createrName:getUserData().userName
        };
        const  customConfig = {
        headers: {
        'Content-Type': 'application/json',
        'Authorization':getAuthHeader().headers.Authorization
        
        }
    };


        try{

           console.log("777777777777777777");
            console.log(shopData)

         console.log(shopData.shopName)
          
         console.log("888888888888888888888");
           
            const request = await axios.post(`${BASE_URL}api/shops/addShp`,shopData,getAuthHeader());
            dispatch(successGlobal('shop created !!'))
            console.log("888888888888888888888");

            console.log(request.data);
            console.log("888888888888888888888");
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
            console.log("333333333333333333333");
            throw error
        }
    }

    
)


export const addShopcontent = createAsyncThunk(
    'shopReducer/addShopContent',
    async(shop,{ dispatch })=>{
        const shopData = {
            id:shop.id,
            title:shop.title,
            shopContent:shop.content,
             languageType:shop.languageType,
             userId:getUserData().userId,
             Visible:shop.Visible,
             priority:1
                     };
        const  customConfig = {
        headers: {
        'Content-Type': 'application/json',
        'Authorization':getAuthHeader().headers.Authorization
        
        }
    };


        try{
          const request = await axios.post(`${BASE_URL}api/shpscntnt/addcntnt`,shopData,getAuthHeader());
            dispatch(successGlobal('shop created !!'))
            

            console.log(request.data);
          
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
          
            throw error
        }
    }

    
)


//Update Shop content
export const updateShopcontent = createAsyncThunk(
    'shopReducer/updateShopcontent',
    async(shop,{ dispatch })=>{
     

        try{

            let myArray = shop.id.split("_");
       
 
            let id1= Number(myArray[0]);
            let trns= Number(myArray[1]);

            const shopData = {
                shopId:id1,
                trsnNo:trns,
                title:shop.title,
                shopContent:shop.content,
                 languageType:shop.languageType,
                 approved:getUserData().userId,
                 Visible:"343433",
                 priority:1
                         }

        

        // console.log(shopData.shopName)
          
       
           
            const request = await axios.post(`${BASE_URL}api/shpscntnt/edite`,shopData,getAuthHeader());
            dispatch(successGlobal('Content Updated !!'))
           

            console.log(request.data);
           
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
            console.log("333333333333333333333");
            throw error
        }
    }

    
)


//GETTING CONTENT BY SHOPE ID  FOR OFFICE USE 
export const getShopContentbyID = createAsyncThunk(
    'shopReducer/getShopContentbyID',
    async(_id,{ dispatch })=>{
        console.log("66666666666");
            console.log(_id);
            console.log("666666");
            const URl=`${BASE_URL}api/shpscntnt/shopcntns/${_id}`;

            console.log(URl);
            console.log("666666");
        
        try{
            const request = await axios.get(URl,getAuthHeader());
            console.log("66666666666");
            console.log(request);
            console.log("666666");

            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
             const ddd=JSON.parse(jsonStr1);
             console.log("66666666666");
             console.log(ddd);
             console.log("666666");
            return ddd;
           
            
            
        } catch(error){
            console.log("666666")
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)



//GETTING MAIN SHOP CATEGORY AND UPDATING THE LIST 
export const getShopMainCategory = createAsyncThunk(
    'shopReducer/getShopMainCategory',
    async(id,{ dispatch })=>{
        const url=`${BASE_URL}api/catgories/mcat`;

      console.log("1111111111");
        console.log(url);
        console.log("111111111111111");
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                //console.log("12121212121"),
                
                //console.log("12121212121"),
               
              );
             // JSONbigint.parse(request.data);
           console.log("2222222222222");
           console.log(request);
            console.log("22222222222");
           // console.log(request.data.categories);
           console.log(request.data.mcatList);

           console.log("3333333333333");
            
            return request.data.mcatList;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)


export const getShopSubCategory = createAsyncThunk(
    'shopAcion/getShopSubCategory',
    async(id,{ dispatch })=>{
        const url=`${BASE_URL}api/catgories/subcat/1`;

      console.log("1111111111");
        console.log(url);
        console.log("111111111111111");
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                //console.log("12121212121"),
                
                //console.log("12121212121"),
               
              );
             // JSONbigint.parse(request.data);
           console.log("2222222222222");
           console.log(request);
            console.log("22222222222");
           // console.log(request.data.categories);
           console.log(request.data.subcateList);

           console.log("3333333333333");
            
            return request.data.subcateList;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)




export const getAllategory = createAsyncThunk(
    'shopReducer/getAllategory',
    async(id,{ dispatch })=>{
        const url=`${BASE_URL}api/catgories/allcatgs`;

      console.log("1111111111");
        console.log(url);
        console.log("111111111111111");
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                //console.log("12121212121"),
                
                //console.log("12121212121"),
               
              );
             // JSONbigint.parse(request.data);
           console.log("2222222222222");
           console.log(request);
            console.log("22222222222");
           // console.log(request.data.categories);
           console.log(request.data.catList);

           console.log("3333333333333");
            
            return request.data.catList;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)


//GETTING IMAGE URLS FOR OFFICE USE 
export const getShopImagesbyID = createAsyncThunk(
    'shopReducer/getShopImagesbyID',
    async(_id,{ dispatch })=>{
        console.log("66666666666");
            console.log(_id);
            console.log("666666");
            const url=`${BASE_URL}api/shpimgs/shpimg/${_id}`;
            console.log(url);
            console.log("666666");
        try{
            const request = await axios.get(url,getAuthHeader());
        

            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
             const ddd=JSON.parse(jsonStr1);
             console.log("66666666666888888888888");
             console.log(ddd);
             console.log("66666666666888888888888");
            return ddd;
           
            //return request.data;
            
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

// UPLOADING SHOP IMAGES 
export const shopImageUpload = createAsyncThunk(
    'shopReducer/shopImageUpload',
    async(data,{ dispatch})=>{
        console.log("111111111111111111");
        const url=`${BASE_URL}upldshopimg`;
        console.log(url);
        console.log(data);
        console.log("111111111111111111");
        data.userID=getUserData().userId;
        console.log(data);
        console.log("111111111111111111");
        try{
            const response = await axios.post(url,data,getAuthHeaderforimage()).then((response) => {
      // handle the response
      console.log("333333");
      console.log(response);
      console.log("444444444");
    })
           
            dispatch(successGlobal('Image is uploaded..!!'))
             return response;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

export const shopImageStatusChange = createAsyncThunk(
    'shopReducer/shopImageStatusChange',
    async({data,addURL},{ dispatch})=>{
        
        try{
            const url=`${BASE_URL}${addURL}`;
            console.log("333333333");
            console.log(url);
        console.log(data);
        console.log("333333333");

            const category = await axios.post(url,data,getAuthHeader());
            

            console.log(url);
            if(category!=null)
            {
                console.log(category);
                console.log("333333333");
                

                if(category.data.message==="success"){
                    dispatch(successGlobal('success fully approved !!'))
                }
                else{
                    dispatch(errorGlobal('kindly check your status!!'))
                }
            }
        
            
            return category.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)


export const shopStatusChange = createAsyncThunk(
    'shopReducer/shopStatusChange',
    async({data,addURL},{ dispatch})=>{
        
        try{
            const url=`${BASE_URL}${addURL}`;
            console.log("333333333");
            console.log(url);
        console.log(data);
        console.log("333333333");

            const category = await axios.post(url,data,getAuthHeader());
            

            console.log(url);
            if(category!=null)
            {
                console.log(category);
                console.log("333333333");
                

                if(category.data.message==="success"){
                    dispatch(successGlobal('success fully approved !!'))
                }
                else{
                    dispatch(errorGlobal('kindly check your status!!'))
                }
            }
        
            
            return category.data;
        } catch(error){
            
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

//ADD SHOP ADRESS
export const addShopAdress = createAsyncThunk(
    'shopReducer/addShopAdress',
    async(shop,{ dispatch })=>{

        
        shop.finalApproved=getUserData().userId;

      try{

            const request = await axios.post(`${BASE_URL}api/shpsadrss/add`,shop,getAuthHeader());
            dispatch(successGlobal('shop Adress !!'))
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           throw error
        }
    }

    
)


//GETTING ADRESS BY SHOPE ID  FOR OFFICE USE 
export const getShopAdressbyID = createAsyncThunk(
    'shopReducer/getShopAdressbyID',
    async(_id,{ dispatch })=>{
        console.log("66666666666");
            console.log(_id);
            console.log("666666");
           
           

    
        let myArray = _id.split("_");
       
 
       let id1= Number(myArray[0]);
       let trns= Number(myArray[1]);
       const URl=`${BASE_URL}api/shpsadrss/shopadrss/${id1}`;
       

       console.log(URl);
       console.log("666666");
        
        try{
            const request = await axios.get(URl,getAuthHeader());
            console.log("66666666666");
            console.log(request);
            console.log("666666");

            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
             const ddd=JSON.parse(jsonStr1);
             console.log("66666666666");
             console.log(ddd);
             console.log("666666");
            return ddd;
           
            
            
        } catch(error){
            console.log("666666")
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)



//ADD SHOP CONTACT INFO
export const addShopContInfo = createAsyncThunk(
    'shopReducer/addShopContInfo',
    async(shop,{ dispatch })=>{

        
        shop.approved=getUserData().userId;

      try{

            const request = await axios.post(`${BASE_URL}api/shpsCntctInfo/add`,shop,getAuthHeader());
            dispatch(successGlobal('shop Contact Information !!'))
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           throw error
        }
    }

    
)


//ADD SHOP CONTACT INFO edite
export const addShopTimng = createAsyncThunk(
    'shopReducer/addShopTimng',
    async(shop,{ dispatch })=>{

        
{
        shop.approved =getUserData().userId;

      try{
 
            const request = await axios.post(`${BASE_URL}api/shpstimming/add`,shop,getAuthHeader());
            dispatch(successGlobal('Shop Timming updated!!'))
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           throw error
        }
    }
})


//GET SHOP PAGINATION
export const getPaginateShops = createAsyncThunk(
    'shopReducer/getPaginateShops',
    async({page=0,limit=10,keywords=''},{ dispatch })=>{
        try{
            


            let url=null;
            if(!((getUserData().role==="ROLE_SHOPRPTR") || (getUserData().role==="ROLE_SHOPEDTR"))){
                url =`${BASE_URL}api/shops/ofcshops?page=${page}&size=${limit}&sort=createdDate,desc`;

            }
            else{
                url =`${BASE_URL}api/shops/ofcshopss?userID=${getUserData().userId}&page=${page}&size=${limit}&sort=createdDate,desc`;
            }

          //  http://localhost:8080/api/news/tutorials?page=0&size=20&sort=createdDate,desc&sort=newsHeading,asc
            const request = await axios.get(url,getAuthHeader()).then(
                console.log("12121212121"),
                (data) => console.log(data),
                console.log("12121212121"),
               
              );
            console.log("6666666");
            console.log(request);
            console.log("6666666");
            console.log(request.data);
            console.log("6666");

            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
             const ddd=JSON.parse(jsonStr1);
            return ddd;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)


//GETTING SHOPS DETAILS FOR OFFICE USE  
export const getShopsOfcView = createAsyncThunk(
    'shopReducer/getShopsOfcView',
    async(id,{ dispatch })=>{
        const url=`${BASE_URL}api/shops/shpdetailsofc/${id}/${getUserData().userId}`;
        console.log("12121212121")
        console.log(url)

        console.log("12121212121")
        
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
             console.log("12121212121")
             console.log(request.data)
     
             console.log("12121212121")
            
            return request.data.shopDetails;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)
    

//GET SHOP DETAILS DATA FOR EDIT 
export const getShopDetails = createAsyncThunk(
    'shopReducer/getShopDetails',
    async(_id,{ dispatch })=>{
        
        try{
            const request = await axios.get(`${BASE_URL}api/news/getOfcNews/${_id}`,getAuthHeader());

           
            return request.data;
            
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)


//ADDING NEW SHOP 
export const editShopdetails = createAsyncThunk(
    'shopReducer/editShopdetails',
    async(shop,{ dispatch })=>{

        const shopData = {
               id:shop.id,
           shopName:shop.shopName,
             shopTitle:shop.shopTitle,
             languageType:shop.languageType,
             userId:getUserData().userId,
             mcatId:shop.mcatId,
             subcatId:shop.subcatId,
              phNo:shop.phNo,
             districtID:shop.districtID,
             talukID:shop.talukID,
             region:1,
             priority:1,
             identity:shop.identity,
             createrName:getUserData().userName
        };
        const  customConfig = {
        headers: {
        'Content-Type': 'application/json',
        'Authorization':getAuthHeader().headers.Authorization
        
        }
    };


        try{

           console.log("777777777777777777");
            console.log(shopData)

         console.log(shopData.shopName)
          
         console.log("888888888888888888888");
           
            const request = await axios.post(`${BASE_URL}api/shops/shpedtnm`,shopData,getAuthHeader());
            dispatch(successGlobal('shop created !!'))
            console.log("888888888888888888888");

            console.log(request.data);
            console.log("888888888888888888888");
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
            console.log("333333333333333333333");
            throw error
        }
    }

    
)

//GETTING SHOPS DETAILS FOR OFFICE USE  
export const getShopContntBytrns= createAsyncThunk(
    'shopReducer/getShopContntBytrns',
    async(id,{ dispatch })=>{

        let myArray = id.split("_");
       
 
       let id1= Number(myArray[0]);
       let trns= Number(myArray[1]);

        const url=`${BASE_URL}api/shpscntnt/shopcntns/${id1}/${trns}`;
        console.log("12121212121")
        console.log(url)

        console.log("12121212121")
        
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
             console.log("12121212121")
             console.log(request.data)
     
             console.log("12121212121")
             
             
            
            return request.data.contentList;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)


//GETTING SHOP ADRESS FOR OFFICE USE  
export const getShopAdressBytrns= createAsyncThunk(
    'shopReducer/getShopAdressBytrns',
    async(id,{ dispatch })=>{

        let myArray = id.split("_");
       
 
       let id1= Number(myArray[0]);
       let trns= Number(myArray[1]);

        const url=`${BASE_URL}api/shpsadrss/shopadrss/${id1}/${trns}`;
        console.log("12121212121")
        console.log(url)

        console.log("12121212121")
        
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
             console.log("12121212121")
             console.log(request.data)
     
             console.log("12121212121")
              return request.data.adressList;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)

//Update Shop ADRESS BY TRANS NO
export const updateShopAdressByTrn = createAsyncThunk(
    'shopReducer/updateShopAdressByTrn',
    async(shop,{ dispatch })=>{
        try{
// console.log(shopData.shopName)
        
            const request = await axios.post(`${BASE_URL}api/shpsadrss/edite`,shop,getAuthHeader());
            dispatch(successGlobal('Content Updated !!'))
           

            console.log(request.data);
           
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
            console.log("333333333333333333333");
            throw error
        }
    }

    
)

//GETTING ADRESS BY SHOPE ID  FOR OFFICE USE 
export const getShopContctInfobyID = createAsyncThunk(
    'shopReducer/getShopContctInfobyID',
    async(_id,{ dispatch })=>{
        console.log("66666666666");
            console.log(_id);
            console.log("666666");
           
           

            let myArray = _id.split("_");
       
 
       let id1= Number(myArray[0]);
       let trns= Number(myArray[1]);
       const URl=`${BASE_URL}api/shpsCntctInfo/cntinfo/${id1}`;
       

       console.log(URl);
       console.log("666666");
        
        try{
            const request = await axios.get(URl,getAuthHeader());
            console.log("66666666666");
            console.log(request);
            console.log("666666");

            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
             const ddd=JSON.parse(jsonStr1);
             console.log("66666666666");
             console.log(ddd);
             console.log("666666");
            return ddd;
           
            
            
        } catch(error){
            console.log("666666")
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

//Update SHOP CONTACT INFO BY TRANS NO
export const updateShopContactByTrn = createAsyncThunk(
    'shopReducer/updateShopContactByTrn',
    async(shop,{ dispatch })=>{
        try{
            const url=`${BASE_URL}api/shpsCntctInfo/edite`;
            

            
            shop.approved=getUserData().userId;

            

        
            const request = await axios.post(url,shop,getAuthHeader());
            dispatch(successGlobal('Content Updated !!'))
           

            console.log(request.data);
           
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
           
            throw error
        }
    }

    
)


//GETTING SHOP CANTACT INFO FOR OFFICE USE  
export const getShopCntInfoBytrns= createAsyncThunk(
    'shopReducer/getShopCntInfoBytrns',
    async(id,{ dispatch })=>{

        let myArray = id.split("_");
       
        
       let id1= Number(myArray[0]);
       let trns= Number(myArray[1]);

        const url=`${BASE_URL}api/shpsCntctInfo/cntinfo/${id1}/${trns}`;
        console.log("12121212121")
        console.log(url)

        console.log("12121212121")
        
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
             console.log("12121212121")
             console.log(request.data)
     
             console.log("12121212121")
             

              return request.data.contList
;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)




//GETTING TIME BY SHOPE ID  FOR OFFICE USE 
export const getShopTimeInfobyID = createAsyncThunk(
    'shopReducer/getShopTimeInfobyID',
    async(_id,{ dispatch })=>{
        console.log("66666666666");
            console.log(_id);
            console.log("666666");
           
           

            let myArray = _id.split("_");
       
 
       let id1= Number(myArray[0]);
       let trns= Number(myArray[1]);
       const URl=`${BASE_URL}api/shpstimming/tmgnfo/${id1}`;
       

       console.log(URl);
       console.log("666666");
        
        try{
            const request = await axios.get(URl,getAuthHeader());
            console.log("66666666666");
            console.log(request);
            console.log("666666");

            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
             const ddd=JSON.parse(jsonStr1);
             console.log("66666666666");
             console.log(ddd);
             console.log("666666");
            return ddd;
           
            
            
        } catch(error){
            console.log("666666")
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)


//GETTING SHOP TIME INFO INFO FOR OFFICE USE  
export const getShopTimeInfoByDayID= createAsyncThunk(
    'shopReducer/getShopTimeInfoByDayID',
    async(id,{ dispatch })=>{

        let myArray = id.split("_");
       
        
       let id1= Number(myArray[0]);
       let trns= Number(myArray[1]);

        const url=`${BASE_URL}api/shpstimming/tmgnfo/${id1}/${trns}`;
        console.log("12121212121")
        console.log(url)

        console.log("12121212121")
        
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
             console.log("12121212121")
             console.log(request.data)
     
             console.log("12121212121")
             
             

              return request.data.timmimg;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)


//UPDATE SHOP TIME INFO FOR OFFICE USE 
export const editeShopTimng = createAsyncThunk(
    'shopReducer/editeShopTimng',
    async(shop,{ dispatch })=>{

        
{
        shop.approved =getUserData().userId;

        console.log("12121212121444")
        console.log(shop)

        console.log("12121212121444")
        

      try{
 
            const request = await axios.post(`${BASE_URL}api/shpstimming/edite`,shop,getAuthHeader());
            dispatch(successGlobal('Shop Timming updated!!'))
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           throw error
        }
    }
})


// GETTING SHOPS FOR HOME PAGE 
export const homeLoadShops = createAsyncThunk(
    'shopReducer/homeLoadShops',
    async(sort,{ dispatch, getState })=>{
        console.log("12121212121")
        try{
            
            //const url=`${BASE_URL}api/shops/headlines/${getUserData().userId}/2/0`;
           const url=`${BASE_URL}api/shops/headlines/${getUserData().userId}/${sort.limit}/${sort.skip}`;
            console.log("1111111111");
            console.log(url);
            console.log("111111111111111");
            const request = await axios.get(url,getAuthHeader());

              let r1 = JSONBigInt.parse(request.request.response);
              let jsonStr=JSONBigInt.stringify(r1);
              const jsonStr1= jsonStr.replace(new RegExp('"shopId":([0-9]+),',"g"),'"shopId":"$1",')
               const ddd=JSON.parse(jsonStr1);
               console.log("66666666666");
               console.log(ddd);
               console.log("666666");
              //JSONbigint.parse(news.data);

              console.log("4444444");

              console.log(getState());

              console.log("4444444");
              

            const state = getState().shopReducer.shops;
            
            
            
             const prevState = [...state];
            const newState = [...prevState,...ddd.shopHeaders]
            console.log("66666666666");
               console.log(newState);
               console.log("666666");
            return { newState,sort }
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            console.log("6666666");
            console.log(error.response.data.message);
            console.log("6666666");
            throw error
        }
    }
)
